export enum NavigationAlignment {
  LEFT = 'left',
  RIGHT = 'right',
}
